<div id = "main-canvas">
    <block-ui>    
        <router-outlet *ngIf="!isIframe" (activate)="componentAdded($event)" (activate)="componentBreadCrumb($event)"></router-outlet>
    </block-ui>
    <app-set-page-titles></app-set-page-titles>
</div>